import React from "react";
import { Route } from "react-router-dom";
import { IAsyncRoute } from "us.collection/interfaces";

const BulkOperation = React.lazy(() => import("../containers/BulkOperation"));
const CaseCloseRules = React.lazy(() => import("../containers/CaseCloseRules"));
const CollectionFee = React.lazy(() => import("../containers/CollectionFee"));
const CourtInfo = React.lazy(() => import("../containers/CourtInfo"));
const Creditors = React.lazy(() => import("../containers/Creditors"));
const CustomSettings = React.lazy(() => import("../containers/CustomSettings"));
const DailyCheckups = React.lazy(() => import("../containers/DailyCheckups"));
const DataProtection = React.lazy(() => import("../containers/DataProtection"));
const Departments = React.lazy(() => import("../containers/Departments"));
const FollowupList = React.lazy(() => import("../containers/FollowupList"));
const InvoiceExportPlugins = React.lazy(
  () => import("../containers/InvoiceExportPlugins")
);
const Municipalities = React.lazy(() => import("../containers/Municipalities"));
const PostalAreas = React.lazy(() => import("../containers/PostalAreas"));
const ProvisionProfiles = React.lazy(
  () => import("../containers/ProvisionProfiles")
);
const Routines = React.lazy(() => import("../containers/Routines"));
const SystemCategory = React.lazy(() => import("../containers/SystemCategory"));
const SystemConfiguration = React.lazy(
  () => import("../containers/SystemConfiguration")
);
const Triggers = React.lazy(() => import("../containers/Triggers"));
const WinMidImport = React.lazy(() => import("../containers/WinMidImport"));
const NonProductionDaysHome = React.lazy(
  () => import("../containers/NonProductionDays/Home")
);
const NonProductionDaysCalendar = React.lazy(
  () => import("../containers/NonProductionDays/Calendar")
);

export default [
  <Route
    key="/bulk-operation"
    path={"/bulk-operation"}
    element={<BulkOperation />}
  />,
  <Route
    key="/case-close-rules"
    path={"/case-close-rules"}
    element={<CaseCloseRules />}
  />,
  <Route
    key="/collection-fee"
    path={"/collection-fee"}
    element={<CollectionFee />}
  />,
  <Route key="/court-info" path={"/court-info"} element={<CourtInfo />} />,
  <Route key="/creditors" path={"/creditors"} element={<Creditors />} />,
  <Route
    key="/custom-settings"
    path={"/custom-settings"}
    element={<CustomSettings />}
  />,
  <Route
    key="/daily-checkups"
    path={"/daily-checkups"}
    element={<DailyCheckups />}
  />,
  <Route
    key="/data-protection"
    path={"/data-protection"}
    element={<DataProtection />}
  />,
  <Route key="/departments" path={"/departments"} element={<Departments />} />,
  <Route
    key="/followup-list"
    path={"/followup-list"}
    element={<FollowupList />}
  />,
  <Route
    key="/invoce-export-plugins"
    path={"/invoce-export-plugins"}
    element={<InvoiceExportPlugins />}
  />,
  <Route
    key="/municipalities"
    path={"/municipalities"}
    element={<Municipalities />}
  />,
  <Route
    key="/postal-areas"
    path={"/postal-areas"}
    element={<PostalAreas />}
  />,
  <Route
    key="/provision-profiles"
    path={"/provision-profiles"}
    element={<ProvisionProfiles />}
  />,
  <Route key="/routines" path={"/routines"} element={<Routines />} />,
  <Route
    key="/system-category"
    path={"/system-category"}
    element={<SystemCategory />}
  />,
  <Route
    key="/system-configuration"
    path={"/system-configuration"}
    element={<SystemConfiguration />}
  />,
  <Route key="/triggers" path={"/triggers"} element={<Triggers />} />,
  <Route
    key="/win-mid-import"
    path={"/win-mid-import"}
    element={<WinMidImport />}
  />,
  <Route
    key="/non-production-days"
    path={"/non-production-days"}
    element={<NonProductionDaysHome />}
  />,
  <Route
    key="non-production-calendar"
    path={"/non-production-days/calendar/:calendarId?"}
    element={<NonProductionDaysCalendar />}
  />,
];

export const BureauContainers: Array<IAsyncRoute> = [
  {
    Container: React.lazy(
      () => import("us.collection.admin/containers/CreditorGroup/Home")
    ),
    Route: "manage-creditor-groups",
  },
  {
    Container: React.lazy(
      () =>
        import(
          "us.collection.routines-and-activities/containers/RoutinesAndActivities"
        )
    ),
    Route: "history",
  },
  {
    Container: React.lazy(() => import("us.collection/containers/BMD")),
    Route: "bmd",
  },
  {
    Container: React.lazy(() => import("us.collection/containers/Workflow")),
    Route: "workflows",
  },
  {
    Container: React.lazy(
      () => import("us.collection/containers/WorkflowTroubleshoot")
    ),
    Route: "workflows-troubleshoot",
  },
  {
    Container: React.lazy(() => import("us.collection/containers/BMD")),
    Route: "",
  },
];
